import PropTypes from 'prop-types';

// material-ui
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';

// project import
// import { drawerWidth } from '../../config';

// ==============================|| HEADER - APP BAR STYLED ||============================== //

// marginLeft: drawerWidth,
// width: `calc(100% - ${drawerWidth}px)`,

const AppBarStyled = styled(AppBar, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  ...(!open && {
    // width: `calc(100% - ${theme.spacing(7.5)})`
    width: '100%'
  }),
  ...(open && {
    // marginLeft: drawerWidth,
    marginLeft: 0,
    //width: `calc(100% - ${drawerWidth}px)`,
    width: '100%',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

AppBarStyled.propTypes = {
  open: PropTypes.bool
};

export default AppBarStyled;
